import React from 'react';
import { Link } from 'react-router-dom';
import StandaloneMarchReport from './StandaloneMarchReport';

/**
 * Standalone March report component with minimal wrapper
 * Provides direct access to the March report without navigation
 */
const PerfectMarchReport: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow max-w-7xl mx-auto">
      <div className="flex justify-between items-center p-4 border-b">
        <div>
          <Link 
            to="/q1-report"
            className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50"
          >
            Q1
          </Link>
        </div>
        <div className="text-base font-semibold text-right">
        </div>
      </div>

      {/* Report Content */}
      <div className="report-container">
        <StandaloneMarchReport />
      </div>
    </div>
  );
};

export default PerfectMarchReport;